<template>
  <div class="home mt-h home_container">
    <Instance
      :itemData="preview_arr"
      v-if="preview_arr.isBanner == 'N' || preview_arr.isBanner == ''"
    />
    <!-- banner -->
    <!-- <Carousel :carousels="carousels" class="carousels" /> -->
    <!--  bettle -->
    <!-- <template v-for="(item,index) in featureData">
      <Battle :itemData="item" :key="index" />
    </template> -->
    <Banner :banners="banners"></Banner>
    <template v-for="(item, index) in imageLinks">
      <ImageLink :itemData="item"></ImageLink>
    </template>
    <!-- date -->
    <template v-for="(item, index) in homeData">
      <DateView :itemData="item" v-if="item.isShowTime" />
      <!--  instance -->
      <Instance :itemData="item" />
    </template>
    <back-top></back-top>
  </div>
</template>

<script>
import Carousel from "./homechild/Carousel.vue";
import Banner from "./homechild/Banner.vue";
import ImageLink from "./homechild/ImageLink.vue";
import Battle from "./homechild/Battle.vue";
import DateView from "./homechild/Date.vue";
import Instance from "./homechild/Instance.vue";
import BackTop from "@/components/common/backtop/BackTop.vue";

import {
  getHomeCarousel,
  getHomeData,
  getHomeFeature,
  postHomeData,
  bannerList,
} from "@/network/home.js";
// getHomeGoods
export default {
  name: "Home",
  components: {
    Banner,
    Carousel,
    Battle,
    DateView,
    Instance,
    BackTop,
    ImageLink,
  },
  data() {
    return {
      banners: [],
      carousels: [],
      instance: [],
      homepagination: {
        page: 0,
        size: 10,
      },
      imageLinks: [],
      homeData: [],
      featureData: [], //专题数据
      loading: true,
      previewPostId: "",
      pcPreviewPostId: "",
      realArr: "",
      preview_flag: false,
      preview_arr: [],
      previewData: "",
    };
  },
  mounted() {
    this.previewPostId = this.$route.query.postId;
    // console.log(this.previewPostId,'------------');
    this.getPreviewData();

    document.title = "ShanghaiEye";
    // 轮播图
    this.getHomeCarousel();
    this.getFeatureFn();
    // // 底部数据
    this.load();
    document.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    document.removeEventListener("scroll", this.loadMore);
  },
  created() {
    this.previewPostId = this.$route.query.postId;
    this.getSendData(); // 首页pc端预览
    this.getBannerData();
    this.getImageLinkData();
  },
  methods: {
    getBannerData() {
      bannerList().then((res) => {
        // console.log("bannerList: ", res);
        this.banners = res.data;
      });
    },
    getImageLinkData() {
      getHomeFeature({
        limit: 2,
        topSuggest: 1,
      }).then((res) => {
        // console.log("getHomeFeature: ", res);
        this.imageLinks = res.data;
      });
    },
    getPreviewData(id) {
      // 通过判断session 区分 手机预览和pc预览 有pc  无手机(扫码进入)
      this.pcPreviewPostId = sessionStorage.getItem("postId");
      var reData = sessionStorage.getItem("reData");
      // console.log(JSON.parse(reData));
      reData = JSON.parse(reData);
      sessionStorage.clear();
      if (id) {
        // alert(id)
        postHomeData({ postId: id }).then((res) => {
          if (res.code == 200 && res.data) {
            this.carousels.unshift(res.data);
          }
        });
      } else {
        // postHomeData({ postId: this.previewPostId }).then((res) => {
        //   if (res.code == 200 && res.data) {
        //     // console.log(1111111);
        //     this.carousels.unshift(res.data);
        //     // 预览处理数据的方法
        //     // console.log(res.data.isBanner)
        //   }
        // });
      }
    },

    getSendData() {
      let self = this;
      this.$nextTick(() => {
        window.addEventListener(
          "message",
          function(event) {
            if (event.data.postId) {
              console.log(event.data, "111111111111");
              this.previewData = event.data;
              this.realArr = event.data.postId;
              let idx = {};
              idx.postId = this.realArr;
              sessionStorage.setItem("postId", this.realArr);
              sessionStorage.setItem(
                "reData",
                JSON.stringify(this.previewData)
              );
              self.getPreviewData(this.realArr);
            }
          },
          false
        );
      });
    },

    // 首页轮播图
    getHomeCarousel() {
      getHomeCarousel().then((res) => {
        // console.log(res.data);
        if (res.data) {
          res.data.forEach((item, index) => {
            if (index < 10) {
              this.carousels.push(item);
            }
          });
        }
      });
    },
    //首页专题
    getFeatureFn() {
      getHomeFeature().then((res) => {
        this.featureData = res.data;
      });
    },
    getHomeData() {
      getHomeData(this.homepagination)
        .then((res) => {
          // this.instance.push(...res);
          this.homeData = this.homeData.concat(res.data);
          // console.log(this.homeData)

          //先对得到的数组进行排序，方法是用a的postDate和a+1的postDate对进行比较
          // for (var i = 0; i < this.homeData.length; i++) {
          //   for (var j = i + 1; j < this.homeData.length; j++) {
          //     if (this.homeData[i].postDate < this.homeData[j].postDate) {
          //       var temp = this.homeData[i];
          //       this.homeData[i] = this.homeData[j];
          //       this.homeData[j] = temp;
          //     }
          //   }
          // }
          // console.log(this.homeData)
          this.homeData.map((item) => {
            var tempTime = "";
            // console.log(item.postDate.length);
            if (item.postDate.length > 10) {
              var aa = item.postDate.substr(0, 10).replace(/-/g, "");
              // var aa = item.postDate.replace(/-/g, "/");
              let yy = aa.slice(0, 4);
              let mm = aa.slice(4, 6);
              let dd = aa.slice(6, 9);
              tempTime = yy + "/" + mm + "/" + dd + " " + "00:00:00";
            } else {
              var aa = item.postDate.replace(/-/g, "/");
              let yy = aa.slice(0, 4);
              let mm = aa.slice(4, 6);
              let dd = aa.slice(6, 9);
              tempTime = yy + "/" + mm + "/" + dd + " " + "00:00:00";
              // console.log(fullDate, "fullDate");
            }
            // console.log(tempTime, "1111");
            // console.log(new Date(tempTime).toDateString(), "bbbb");

            var mthNum = new Date(tempTime).getMonth();
            var allmth = new Array(
              "January",
              "February",
              "March",
              "April ",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December"
            );
            item.tempMonth = allmth[mthNum];
            // console.log(item.tempMonth, "aaaaaaaaaa");

            item.tempDay = new Date(tempTime).getDate();
            item.tempDate = item.postDate.split(" ")[0];
          });
          // console.log(this.homeData, "this.homeData111");
          let tempV = this.homeData[0]["tempDate"];
          this.homeData[0]["isShowTime"] = true;
          for (let i = 0; i < this.homeData.length; i++) {
            if (tempV == this.homeData[i + 1]["tempDate"]) {
              this.homeData[i + 1]["isShowTime"] = false;
              // console.log(44444444444,this.homeData[i + 1]["tempDate"])
            } else {
              // console.log(555555555555, tempV);
              tempV = this.homeData[i + 1]["tempDate"];
              this.homeData[i + 1]["isShowTime"] = true;
            }
          }
          this.loading = true;
          // console.log(this.homeData, "this.homeData222");
        })
        .catch((res) => {
          this.loading = true;
        });
    },
    //滚动到底部加载更多
    load() {
      if (this.loading) {
        // console.log(this.loading,'------------aaaaaa-----------------')
        this.loading = false;
        setTimeout(() => {
          // console.log('11111111111111111111')
          this.homepagination.page = this.homepagination.page + 1; // 加载更多是definePageNum+1
          this.getHomeData(this.homepagination);
        }, 100);
      }
    },
    //触发滚动
    loadMore() {
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight; //document的滚动高度
      let nowScotop =
        document.documentElement.clientHeight || document.body.clientHeight; //可视区高度
      let wheight =
        document.documentElement.scrollTop || document.body.scrollTop; //已滚动高度
      // console.log(nowScotop, "----", scrollHeight - wheight - 500, "height");
      if (this.loading) {
        if (nowScotop >= scrollHeight - wheight - 500) {
          setTimeout(() => {
            this.load(); //加载列表的请求方法
          }, 100);
        }
      }
    },
  },
  computed: {
    newNum() {
      return this.$store.getters.test;
    },
  },
};
</script>
<style lang="less">
.home {
  overflow: hidden;
  .carousels:hover {
    .carousel-control-prev-icon {
      display: block;
    }

    .carousel-control-next-icon {
      display: block;
    }
  }

  .carousel-control-prev-icon {
    height: 30px;
    width: 17px;
    display: block;
    background: url("../../assets/imgs/home/left.png") no-repeat;
    background-size: 100% 100%;
    display: none;
  }

  .carousel-control-next-icon {
    height: 30px;
    width: 17px;
    display: block;
    background: url("../../assets/imgs/home/right.png") no-repeat;
    display: none;
    background-size: 100% 100%;
  }
}

.innerbox .metro-btn {
  padding: 1px 3px 1px 7px !important;
}

@media screen and (min-width: 768px) {
  .home {
    padding: 0 18%;
    overflow: hidden;
  }
}

@media screen and (max-width: 768px) {
  .home {
    .carousel-control-prev-icon {
      height: 0px;
      // display: inline;
      width: 0px;
    }

    .carousel-control-next-icon {
      // display: inline;
      height: 0px;
      width: 0px;
    }
  }
}
</style>
